import 'swiper/css'

import {Box, Grid} from '@logistics-frontend/blocks'
import React, {useCallback, useRef, useState} from 'react'
import SwiperClass, {Autoplay} from 'swiper'
import {Swiper, SwiperRef, SwiperSlide} from 'swiper/react'

import {useIsMobile} from '../../hooks'
import {StoriesBar} from '../stories-bar'
import * as classes from './AutoBanner.classes'
import {usePromotions} from './AutoBanner.hooks'
import {AutoBannerSlide} from './slide'

export function AutoBanner(): React.ReactElement | null {
  const {
    promotions: {banners, isAutoScrollEnabled},
    isPending,
  } = usePromotions()
  const [currentStoryId, setCurrentStoryId] = useState(0)
  const isMobile = useIsMobile()
  const swiperRef = useRef<SwiperRef>(null)

  const changeBannerSlide = useCallback((nextStoryId: number) => {
    swiperRef.current?.swiper.slideTo(nextStoryId)
  }, [])

  const onSlideChange = useCallback(
    (swiper: SwiperClass) => {
      if (!isAutoScrollEnabled) {
        return
      }

      setCurrentStoryId(swiper.activeIndex)
    },
    [isAutoScrollEnabled],
  )

  if (isPending) {
    return null
  }

  if (isMobile) {
    return (
      <Box onTouchMove={e => e.stopPropagation()} onTouchStart={e => e.stopPropagation()} pb="s">
        <Grid container>
          {banners.length === 1 ? (
            <Grid className={classes.banner} xs={12} item>
              <AutoBannerSlide {...banners[0]} />
            </Grid>
          ) : (
            <Swiper
              ref={swiperRef}
              autoplay={{
                delay: 10000,
              }}
              className={classes.swiper}
              modules={isAutoScrollEnabled ? [Autoplay] : []}
              slidesPerView={1.05}
              spaceBetween={8}
            >
              {banners.map(slide => (
                <SwiperSlide key={slide.id} className={classes.slide}>
                  <AutoBannerSlide {...slide} />
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </Grid>
      </Box>
    )
  }

  return (
    <div>
      {banners.length === 1 ? (
        <AutoBannerSlide {...banners[0]} />
      ) : (
        <>
          <Swiper
            ref={swiperRef}
            allowTouchMove={false}
            autoplay={{
              disableOnInteraction: false,
              delay: 10000,
            }}
            modules={isAutoScrollEnabled ? [Autoplay] : []}
            onSlideChange={onSlideChange}
          >
            {banners.map(slide => (
              <SwiperSlide key={slide.id} className={classes.slide}>
                <AutoBannerSlide {...slide} />
              </SwiperSlide>
            ))}
          </Swiper>
          {isAutoScrollEnabled && (
            <Box px="s" py="xs">
              <StoriesBar
                currentStoryId={currentStoryId}
                onClick={nextStory => {
                  changeBannerSlide(nextStory)
                }}
                storiesAmount={banners.length}
              />
            </Box>
          )}
        </>
      )}
    </div>
  )
}
